export default "__VITE_ASSET__Cx$gkaCT__"